import { useState } from "react";
import { toast } from "sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Benefits } from "@/components/landing/Benefits";
import { RewardBanner } from "@/components/landing/RewardBanner";
import { Steps } from "@/components/landing/Steps";
import { Trust } from "@/components/landing/Trust";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";
import { SuccessDialog } from "@/components/landing/SuccessDialog";
import { StickyCta } from "@/components/landing/StickyCta";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

export default function Landing() {
  const [lead, setLead] = useState(null);

  const handleSuccess = (newLead) => {
    setLead(newLead);
    toast.success("¡Solicitud enviada! Tu bono de $50 está listo.");
  };

  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Header />
      <main>
        <Hero onSuccess={handleSuccess} />
        <Marquee />
        <Benefits />
        <RewardBanner />
        <Steps />
        <Trust />
        <FAQ />
      </main>
      <Footer />
      <StickyCta />
      <WhatsAppFloat />
      <SuccessDialog lead={lead} onClose={() => setLead(null)} />
    </div>
  );
}
